import { Section } from '@/shared/ui/Section';

interface AboutStaffProps {
  name: string;
  about: string | null;
}

export const AboutStaff = ({ name, about }: AboutStaffProps) => (
  <Section typeSection="section">
    <h2 className="text-[32px] font-medium mb-4">About {name}</h2>
    <p className="text-sm text-black-headline">{about?.trim() ? about : '—'}</p>
  </Section>
);
